<p-toast></p-toast>
<div>
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                </ng-template>
                <ng-template pTemplate="right">
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}" icon="pi pi-upload"
                        class="p-button-help"></button> -->
                    <p-splitButton [model]="menuItems" icon="pi pi-download"
                        label="{{'EXPORT' | translate}}"></p-splitButton>
                    <!-- <p-menu #menu [popup]="true" [model]="menuItems"></p-menu> -->
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                </ng-template>

            </p-toolbar>

            <p-table #subsidyToVendorPFMSReportTable [value]="subsidyToVendorPFMSReportModel" [rows]="10"
                [paginator]="true"
                [globalFilterFields]="['Srno','Lot_No','dateofExport','Sum_of_PFMS_Export', 'SumOfPendingRecords', 'TargetDays', 'PendingCompletedDays', 'NoOfTimesExported', 'Sum_of_Centre_Share_AllRec', 'Sum_of_Centre_Share_FailedRec','Sum_of_Centre_Share_PenRec','Sum_of_Centre_Share_SuccessfullRec','Sum_of_State_Share_AllRec', 'Sum_of_State_Share_FailedRec','Sum_of_State_Share_PenRec','Sum_of_State_Share_SuccessfullRec', 'Sum_of_Successfull_Records','Sum_of_Failed_Records', 'Sum_of_Bank_Transfer_Successfull_Records', 'block', 'district', 'No_of_Record', 'remarks', 'status','Status_Ar', 'village', 'lotNoForSorting', 'FinYear', 'NoOfPendingRecords', 'No_of_Failed_Records', 'No_of_Successfull_Records', 'NoOfSuccessfullBankRec', 'Total_Sum', 'TopUp_All']"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                [showCurrentPageReport]="true" sortField="lotNoForSorting" [sortOrder]="1" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'SUBSIDY_TO_VENDOR_PFMS_REPORTS' | translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="subsidyToVendorPFMSReportTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH' | translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th pSortableColumn="Srno">{{'S_NO'| translate}}
                            <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                            <p-sortIcon field="Srno"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="lotNoForSorting">{{'FILE_NO'| translate}}
                            <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                            <p-sortIcon field="lotNoForSorting"></p-sortIcon>
                        </th>
                        <th pSortableColumn="dateofExport">{{'DATE_OF_EXPORT'| translate}}
                            <p-columnFilter type="text" field="dateofExport" display="menu"></p-columnFilter>
                            <p-sortIcon field="dateofExport"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Total_Sum">{{'TOTAL_SUM'| translate}}
                            <p-columnFilter type="text" field="Total_Sum" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Sum"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_PFMS_Export">{{'SUM_OF_PFMS_EXPORT'| translate}}
                            <p-columnFilter type="text" field="Sum_of_PFMS_Export" display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_PFMS_Export"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TargetDays">{{'TARGET_DAYS' | translate}}
                            <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="TargetDays"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                            <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                        </th>
                        <th *ngIf="!isCAOLogin" pSortableColumn="NoOfTimesExported">{{'NO_OF_TIMES_EXPORTED' |
                            translate}}
                            <p-columnFilter type="text" field="NoOfTimesExported" display="menu"></p-columnFilter>
                            <p-sortIcon field="NoOfTimesExported"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Sum_of_Centre_Share_AllRec">{{'SUM_OF_CENTRE_SHARE_(ALL_RECORDS)'|
                            translate}}
                            <p-columnFilter type="text" field="Sum_of_Centre_Share_AllRec"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_Centre_Share_AllRec"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_State_Share_AllRec">{{'SUM_OF_STATE_SHARE_(ALL_RECORDS)'|
                            translate}}
                            <p-columnFilter type="text" field="Sum_of_State_Share_AllRec"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_State_Share_AllRec"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TopUp_All">{{'SUM_OF_TOP_UP_(ALL_RECORDS)'| translate}}
                            <p-columnFilter type="text" field="TopUp_All" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="TopUp_All"></p-sortIcon>
                        </th>


                        <th pSortableColumn="SumOfCenterShare_Success">{{'SUM_OF_CENTRE_SHARE_(SUCCESSFUL_RECORDS)'|
                            translate}}
                            <p-columnFilter type="text" field="SumOfCenterShare_Success"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="SumOfCenterShare_Success"></p-sortIcon>
                        </th>
                        <th pSortableColumn="SumOfStateShare_Success">{{'SUM_OF_STATE_SHARE_(SUCCESSFUL_RECORDS)'|
                            translate}}
                            <p-columnFilter type="text" field="SumOfStateShare_Success" display="menu"></p-columnFilter>
                            <p-sortIcon field="SumOfStateShare_Success"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TopUp_Success">{{'SUM_OF_TOP_UP_(SUCCESSFUL_RECORDS)'| translate}}
                            <p-columnFilter type="text" field="TopUp_Success" display="menu"></p-columnFilter>
                            <p-sortIcon field="TopUp_Success"></p-sortIcon>
                        </th>


                        <th *ngIf="!isCAOLogin" pSortableColumn="Sum_of_Centre_Share_PenRec">
                            {{'SUM_OF_CENTRE_SHARE_(PENDING_RECORDS)'| translate}}
                            <p-columnFilter type="text" field="Sum_of_Centre_Share_PenRec"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_Centre_Share_PenRec"></p-sortIcon>
                        </th>
                        <th *ngIf="!isCAOLogin" pSortableColumn="Sum_of_State_Share_PenRec">
                            {{'SUM_OF_STATE_SHARE_(PENDING_RECORDS)'| translate}}
                            <p-columnFilter type="text" field="Sum_of_State_Share_PenRec"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_State_Share_PenRec"></p-sortIcon>
                        </th>
                        <th *ngIf="!isCAOLogin" pSortableColumn="TopUp_Pend">{{'SUM_OF_TOP_UP_(PENDING_RECORDS)'|
                            translate}}
                            <p-columnFilter type="text" field="TopUp_Pend" display="menu"></p-columnFilter>
                            <p-sortIcon field="TopUp_Pend"></p-sortIcon>
                        </th>



                        <th pSortableColumn="Sum_of_Centre_Share_FailedRec">{{'SUM_OF_CENTRE_SHARE_(FAILED_RECORDS)'|
                            translate}}
                            <p-columnFilter type="text" field="Sum_of_Centre_Share_FailedRec"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_Centre_Share_FailedRec"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_State_Share_FailedRec">{{'SUM_OF_STATE_SHARE_(FAILED_RECORDS)'|
                            translate}}
                            <p-columnFilter type="text" field="Sum_of_State_Share_FailedRec"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_State_Share_FailedRec"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TopUp_Failed">{{'SUM_OF_TOP_UP_(FAILED_RECORDS)'| translate}}
                            <p-columnFilter type="text" field="TopUp_Failed" display="menu"></p-columnFilter>
                            <p-sortIcon field="TopUp_Failed"></p-sortIcon>
                        </th>

                        <th pSortableColumn="No_of_Record">{{'NO_OF_RECORDS'| translate}}
                            <p-columnFilter type="text" field="No_of_Record" display="menu"></p-columnFilter>
                            <p-sortIcon field="No_of_Record"></p-sortIcon>
                        </th>
                        <th pSortableColumn="No_of_Successfull_Records">{{'NO_OF_SUCCESSFULL_RECORDS'| translate}}
                            <p-columnFilter type="text" field="No_of_Successfull_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="No_of_Successfull_Records"></p-sortIcon>
                        </th>
                        <th *ngIf="!isCAOLogin" pSortableColumn="NoOfPendingRecords">{{'NO_OF_PENDING_RECORDS'|
                            translate}}
                            <p-columnFilter type="text" field="NoOfPendingRecords" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="NoOfPendingRecords"></p-sortIcon>
                        </th>
                        <th pSortableColumn="No_of_Failed_Records">{{'NO_OF_FAILED_RECORDS'| translate}}
                            <p-columnFilter type="text" field="No_of_Failed_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="No_of_Failed_Records"></p-sortIcon>
                        </th>


                        <th pSortableColumn="Sum_of_Successfull_Records">{{'SUM_OF_SUCCESSFULL_RECORDS'| translate}}
                            <p-columnFilter type="text" field="Sum_of_Successfull_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Sum_of_Successfull_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="SumOfPendingRecords">{{'SUM_OF_PENDING_RECORDS'| translate}}
                            <p-columnFilter type="text" field="SumOfPendingRecords" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="SumOfPendingRecords"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_Failed_Records">{{'SUM_OF_FAILED_RECORDS'| translate}}
                            <p-columnFilter type="text" field="Sum_of_Failed_Records" display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_Failed_Records"></p-sortIcon>
                        </th>

                        <th pSortableColumn="NoOfSuccessfullBankRec">{{'NO_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'|
                            translate}}
                            <p-columnFilter type="text" field="NoOfSuccessfullBankRec" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="NoOfSuccessfullBankRec"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_Bank_Transfer_Successfull_Records">
                            {{'SUM_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                            <p-columnFilter type="text" field="Sum_of_Bank_Transfer_Successfull_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Sum_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <!-- <td>{{product.Srno}}</td> -->
                        <td><button (click)="pmfsExport(product.Lot_No, '')" pButton pRipple type="button"
                                label="{{product.Lot_No}}" class="p-button-text"></button></td>
                        <td>{{product.dateofExport}}</td>
                        <td>{{product.Total_Sum}}</td>
                        <td>{{product.Sum_of_PFMS_Export}}</td>
                        <td>{{product.TargetDays}}</td>
                        <td>{{product.PendingCompletedDays}}</td>
                        <td *ngIf="!isCAOLogin">{{product.NoOfTimesExported}}</td>

                        <td>{{product.Sum_of_Centre_Share_AllRec}}</td>
                        <td>{{product.Sum_of_State_Share_AllRec}}</td>
                        <td>{{product?.TopUp_All}}</td>

                        <td>{{product.SumOfCenterShare_Success}}</td>
                        <td>{{product.SumOfStateShare_Success}}</td>
                        <td>{{product.TopUp_Success}}</td>

                        <td *ngIf="!isCAOLogin">{{product.Sum_of_Centre_Share_PenRec}}</td>
                        <td *ngIf="!isCAOLogin">{{product.Sum_of_State_Share_PenRec}}</td>
                        <td *ngIf="!isCAOLogin">{{product.TopUp_Pend}}</td>

                        <td>{{product.Sum_of_Centre_Share_FailedRec}}</td>
                        <td>{{product.Sum_of_State_Share_FailedRec}}</td>
                        <td>{{product.TopUp_Failed}}</td>

                        <td>{{product.No_of_Record}}</td>
                        <td>{{product?.No_of_Successfull_Records}}</td>
                        <td *ngIf="!isCAOLogin">{{product?.NoOfPendingRecords}}</td>
                        <td>{{product?.No_of_Failed_Records}}</td>

                        <td><button (click)="pmfsExport(product.Lot_No, 'S')" pButton pRipple type="button"
                                label="{{product?.Sum_of_Successfull_Records}}" class="p-button-text"></button></td>
                        <td><button (click)="pmfsExport(product.Lot_No, 'P')" pButton pRipple type="button"
                                label="{{product?.SumOfPendingRecords}}" class="p-button-text"></button></td>
                        <td><button (click)="pmfsExport(product.Lot_No, 'F')" pButton pRipple type="button"
                                label="{{product?.Sum_of_Failed_Records}}" class="p-button-text"></button></td>

                        <td>{{product?.NoOfSuccessfullBankRec}}</td>
                        <td>{{product.Sum_of_Bank_Transfer_Successfull_Records}}</td>
                        <td>{{product.FinYear}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{subsidyToVendorPFMSReportModel ?
                            subsidyToVendorPFMSReportModel.length : 0 }} {{'RECORDS_ADDED'| translate}}
                        </p>
                        <div class="flex  justify-content-between flex-column ">
                            <div class="flex">
                                <div
                                    style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'PENDING_THREE_OR_MORE_DAYS' | translate}}
                            </div>
                            <div class="flex">
                                <div
                                    style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'PENDING_BY_ONE_OR_TWO_DAYS' | translate}}
                            </div>
                            <div class="flex">
                                <div
                                    style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'APPROVED_ON_TIME' | translate}}
                            </div>
                        </div>
                    </div>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<p-dialog [(visible)]="addDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
    <div *ngIf="loading1" class="flex justify-content-center align-items-center">
        <p-progressSpinner styleClass="custom-spinner" ariaLabel="loading" strokeWidth="3" fill="#EEEEEE"
            animationDuration="1s"></p-progressSpinner>
        <h4>Loading...</h4>
    </div>
    <div *ngIf="!loading1" class="mi-survey-container">
        <!-- <p-card styleClass="p-card-shadow"> -->
        <!-- <div class="card dashboardTable">
                <p-table #miSurvey [value]="miSurveyData" [rows]="10"
                    [paginator]="true" [globalFilterFields]="[
                    'Full_Name_in_Recognized_Official_Language',
                    'Full_Name_In_English',
                    'Caste_Description',
                    'GST_NO',
                    'Address_Line_1',
                    'Address_Line_2',
                    'Address_Line_3',
                    'District',
                    'State', 
                    'Country', 
                    'Vendor_Bank_Name', 
                    'Vendor_IFSC_Code',
                    'Vendor_Account_Number', 
                    'Vendor_Pan_Card_No', 
                    'Pincode', 
                    'Scheme_Specific_Id',
                    'Center_Share_Payment_Amount',
                    'State_Share_Payment_Amount',
                    'Remarks',
                    'ChallanNo',
                    'UTR',
                    'CreditedOnDateTime',
                    'Programme_Name',
                    'UserType',
                    'Applicant_type',
                    'MIArea',
                    'CAORemarks',
                    'TopUp',
                    'Total_Area',
                    'Crop_Name',
                    'FarmerType',
                    'Block',
                    'Village',
                    'Aadhar_No',
                    'TopUpPFMSPaymentDate'
                    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
                    currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                    [showCurrentPageReport]="true" [loading]="loading1">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MI_SUBSIDY_TO_VENDOR_LOT' | translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH' | translate}}" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th>
                            <th pSortableColumn="Full_Name_In_English">{{'FULL_NAME_IN_ENGLISH' | translate}}
                                <p-columnFilter type="text" field="Full_Name_In_English" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Full_Name_In_English"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Full_Name_in_Recognized_Official_Language">{{'FULL_NAME_IN_RECOGNIZED_OFFICIAL_LANGUAGE' | translate}}
                                <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Caste_Description">
                                {{'CASTE' | translate}}
                                <p-columnFilter type="text" field="Caste_Description"
                                    display="menu"></p-columnFilter>
                                <p-sortIcon field="Caste_Description"></p-sortIcon>
                            </th>
                            <th pSortableColumn="GST_NO">{{'GST_NO' | translate}}
                                <p-columnFilter type="text" field="GST_NO" display="menu"></p-columnFilter>
                                <p-sortIcon field="GST_NO"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_1">{{'ADDRESSLINE1' | translate}}
                                <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_1"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_2">{{'ADDRESSLINE2' | translate}}
                                <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_2"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_3">{{'ADDRESSLINE3' | translate}}
                                <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_3"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Village">{{'Village' | translate}}
                                <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                                <p-sortIcon field="Village"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Block">{{'BLOCK' | translate}}
                                <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                                <p-sortIcon field="Block"></p-sortIcon>
                            </th>
                            <th pSortableColumn="District">{{'DISTRICT' | translate}}
                                <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                                <p-sortIcon field="District"></p-sortIcon>
                            </th>
                            <th pSortableColumn="State">{{'STATE' | translate}}
                                <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                                <p-sortIcon field="State"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Country">{{'COUNTRY' | translate}}
                                <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                                <p-sortIcon field="Country"></p-sortIcon>
                            </th>
                            <th pSortableColumn="FarmerType">{{'FARMER_TYPE' | translate}}
                                <p-columnFilter type="text" field="FarmerType" display="menu"></p-columnFilter>
                                <p-sortIcon field="FarmerType"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Bank_Name">{{'VENDOR_BANK_NAME' | translate}}
                                <p-columnFilter type="text" field="Vendor_Bank_Name" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_Bank_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_IFSC_Code">{{'VENDOR_IFSCCODE' | translate}}
                                <p-columnFilter type="text" field="Vendor_IFSC_Code" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_IFSC_Code"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Account_Number">{{'VENDOR_ACCOUNT_NUMBER' | translate}}
                                <p-columnFilter type="text" field="Vendor_Account_Number" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Vendor_Account_Number"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Pan_Card_No">{{'VENDOR_PAN_CARD_NO' | translate}}
                                <p-columnFilter type="text" field="Vendor_Pan_Card_No" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_Pan_Card_No"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Aadhar_No">{{'AADHAR_NUMBER' | translate}}
                                <p-columnFilter type="text" field="Aadhar_No" display="menu"></p-columnFilter>
                                <p-sortIcon field="Aadhar_No"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Pincode">{{'PINCODE' | translate}}
                                <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                                <p-sortIcon field="Pincode"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID' | translate}}
                                <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                                <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ChallanNo">{{'CHALLAN_NO' | translate}}
                                <p-columnFilter type="text" field="ChallanNo" display="menu"></p-columnFilter>
                                <p-sortIcon field="ChallanNo"></p-sortIcon>
                            </th>
                            <th pSortableColumn="UTR">{{'UTR' | translate}}
                                <p-columnFilter type="text" field="UTR" display="menu"></p-columnFilter>
                                <p-sortIcon field="UTR"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CreditedOnDateTime">{{'CREDITED_DATE' | translate}}
                                <p-columnFilter type="text" field="CreditedOnDateTime" display="menu"></p-columnFilter>
                                <p-sortIcon field="CreditedOnDateTime"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Center_Share_Payment_Amount">{{'CENTER_SHARE_PAYMENT_AMOUNT' | translate}}
                                <p-columnFilter type="text" field="Center_Share_Payment_Amount" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Center_Share_Payment_Amount"></p-sortIcon>
                            </th>
                            <th pSortableColumn="State_Share_Payment_Amount">{{'STATE_SHARE_PAYMENT_AMOUNT' | translate}}
                                <p-columnFilter type="text" field="State_Share_Payment_Amount" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TopUp">{{'TOP_UP' | translate}}
                                <p-columnFilter type="text" field="TopUp" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="TopUp"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Programme_Name">{{'PROGRAMME_NAME' | translate}}
                                <p-columnFilter type="text" field="Programme_Name" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Programme_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Crop_Name">{{'CROP_NAME' | translate}}
                                <p-columnFilter type="text" field="Crop_Name" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Crop_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="UserType">{{'USER_TYPE' | translate}}
                                <p-columnFilter type="text" field="UserType" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="UserType"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Applicant_type">{{'APPLICATION_TYPE' | translate}}
                                <p-columnFilter type="text" field="Applicant_type" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Applicant_type"></p-sortIcon>
                            </th>
                            <th pSortableColumn="MIArea">{{'MIAREA' | translate}}
                                <p-columnFilter type="text" field="MIArea" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="MIArea"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Total_Area">{{'TOTAL_LAND_HOLDING' | translate}}
                                <p-columnFilter type="Total_Area" field="Total_Area" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="MIArea"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Remarks">{{'REMARKS' | translate}}
                                <p-columnFilter type="text" field="Remarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Remarks"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CAORemarks">{{'CAO_REMARKS' | translate}}
                                <p-columnFilter type="text" field="CAORemarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="CAORemarks"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TopUpPFMSPaymentDate">{{'TOP_UP_PFMS_PAYMENT_DATE'| translate}}
                                <p-columnFilter type="text" field="TopUpPFMSPaymentDate" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="TopUpPFMSPaymentDate"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>
                                <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectFarmerApplication(product)"></button>
                            </td>
                            <td>{{product?.Full_Name_In_English}}</td>
                            <td>{{product?.Farmer_Name_In_English}}</td>
                            <td>{{product?.Caste_Description}}</td>
                            <td>{{product?.GST_NO}}</td>
                            <td>{{product?.Address_Line_1}}</td>
                            <td>{{product?.Address_Line_2}}</td>
                            <td>{{product?.Address_Line_3}}</td>
                            <td>{{product?.Village}}</td>
                            <td>{{product?.Block}}</td>
                            <td>{{product?.District}}</td>
                            <td>{{product?.State}}</td>
                            <td>{{product?.Country}}</td>
                            <td>{{product?.FarmerType}}</td>
                            <td>{{product?.Vendor_Bank_Name}}</td>
                            <td>{{product?.Vendor_IFSC_Code}}</td>
                            <td>{{product?.Vendor_Account_Number}}</td>
                            <td>{{product?.Vendor_Pan_Card_No}}</td>
                            <td>{{product?.Aadhar_No}}</td>
                            <td>{{product?.Pincode}}</td>
                            <td>{{product?.Scheme_Specific_Id}}</td>
                            <td>{{product?.ChallanNo}}</td>
                            <td>{{product?.UTR}}</td>
                            <td>{{product?.CreditedOnDateTime | date:'mediumDate'}}</td>
                            <td>{{product?.Center_Share_Payment_Amount}}</td>
                            <td>{{product?.State_Share_Payment_Amount}}</td>
                            <td>{{product?.TopUp}}</td>
                            <td>{{product?.Programme_Name}}</td>
                            <td>{{product?.Crop_Name}}</td>
                            <td>{{product?.UserType}}</td>
                            <td>{{product?.Applicant_type}}</td>
                            <td>{{product?.MIArea}}</td>
                            <td>{{product?.Total_Area}}</td>
                            <td>{{product?.Remarks}}</td>
                            <td>{{product?.CAORemarks}}</td>
                            <td>{{product?.TopUpPFMSPaymentDate}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex  justify-content-between flex-column ">
                            <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }} {{'MI_FARMER_SHARE_TO_VENDOR_LOT_APPLICATIONS_ADDED' | translate}}
                            </p>
                            <div class="flex  justify-content-between flex-column "> 
                                <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_TWO_OR_MORE_DAYS' | translate}}</div>
                                <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY' | translate}}</div>
                                <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APROVED_ON_TIME' | translate}}</div>
                            </div>
                        </div>
                    </ng-template>
                </p-table>
            </div> -->


        <div class="card dashboardTable">
            <div class="container mt-4">
                <!-- Filter controls -->
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="input-group">
                            <!-- <span class="input-group-text">Filter</span> -->
                            <input type="text" class="form-control" pInputText placeholder="Search Vendors..."
                                [(ngModel)]="filterText" (input)="applyFilter()">
                        </div>
                    </div>
                    <div class="col-md-6 text-end">
                        <!-- <button class="btn btn-outline-primary me-2" (click)="exportToExcel()">
                        <i class="pi pi-file-excel"></i> Export to Excel
                    </button> -->
                    </div>
                </div>

                <!-- Vendor tables -->
                <div *ngFor="let vendor of filteredVendors; let vendorIndex = index"
                    class="vendor-table-container mb-4">
                    <!-- Vendor header -->
                    <div class="vendor-header p-2 mb-2 bg-light">
                        <h5 class="mb-1">{{ vendor.vendorName }}</h5>
                        <div class="vendor-details">
                            <span class="me-3"><strong>GST NO:</strong> {{ vendor.gstNo }}</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span><strong>Pan Card No:</strong> {{ vendor.panNo }}</span>
                        </div>
                    </div>

                    <!-- Data table -->
                    <div class="table-responsive">
                        <p-table [value]="vendor.items" styleClass="p-datatable-gridlines vendor-data-table"
                            [paginator]="true" [rows]="10" dataKey="Scheme_Specific_Id" [loading]="loading1"
                            responsiveLayout="scroll" [rowHover]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Lot No.</th>
                                    <th>View Application</th>
                                    <th>Application No</th>
                                    <th>Farmer Name</th>
                                    <th>Farmer Type</th>
                                    <th>Village</th>
                                    <th>Block</th>
                                    <th>District</th>
                                    <th>Cate Description</th>
                                    <th>MI Type</th>
                                    <th>MI Area</th>
                                    <th>Farmer Share</th>
                                    <th>Credited Date</th>
                                    <th>Center Share Payment</th>
                                    <th>State Share Payment</th>
                                    <th>Top up</th>
                                    <th>Total Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                <tr>
                                    <td>{{ rowIndex + 1 }}</td>
                                    <td>{{ lotNo }}</td>
                                    <td>
                                        <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}"
                                            icon="pi pi-file" class="p-button-rounded p-button-accent mr-1 btnSize"
                                            (click)="selectFarmerApplication(item)"></button>
                                    </td>
                                    <td>{{ item.Scheme_Specific_Id }}</td>
                                    <td>{{ item.farmerName }}</td>
                                    <td>{{ item.FarmerType }}</td>
                                    <td>{{ item.Village }}</td>
                                    <td>{{ item.Block }}</td>
                                    <td>{{ item.District }}</td>
                                    <td>{{ item.Caste_Description }}</td>
                                    <td>{{ item.Programme_Name }}</td>
                                    <td>{{ item.MIArea }}</td>
                                    <td>{{ item.FarmerShareAmt | number }}</td>
                                    <td>{{ item.CreditedOnDateTime }}</td>
                                    <td>{{ item.Center_Share_Payment_Amount | number }}</td>
                                    <td>{{ item.State_Share_Payment_Amount | number }}</td>
                                    <td>{{ item.TopUp | number }}</td>
                                    <td>{{ calculateTotal(item) | number }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td colspan="11" class="text-end fw-bold">Vendor Totals:</td>
                                    <td class="fw-bold">{{ getVendorTotalArea(vendor) | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getVendorTotalFarmerShare(vendor) | number:'1.2-2' }}</td>
                                    <td></td>
                                    <td class="fw-bold">{{ getVendorTotalCenterShare(vendor) | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getVendorTotalStateShare(vendor) | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getVendorTotalTopUp(vendor) | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getVendorTotalAmount(vendor) | number:'1.2-2' }}</td>
                                </tr>
                            </ng-template>
                            <!-- <ng-template pTemplate="summary">
                            <div class="flex  justify-content-between flex-column ">
                                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }} {{'MI_FARMER_SHARE_TO_VENDOR_LOT_APPLICATIONS_ADDED' | translate}}
                                </p>
                                <div class="flex  justify-content-between flex-column "> 
                                    <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_TWO_OR_MORE_DAYS' | translate}}</div>
                                    <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY' | translate}}</div>
                                    <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APROVED_ON_TIME' | translate}}</div>
                                </div>
                            </div>
                        </ng-template> -->
                        </p-table>
                    </div>
                </div>

                <!-- Grand totals -->
                <div class="grand-totals p-3 mt-4 bg-light" *ngIf="filteredVendors.length > 0">
                    <div class="flex justify-content-center grand-total-header">
                        <p>{{ miCertificateData?.Program_Name }}</p>
                    </div>

                    <!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <div class="field md:col-3 col-12">
                            <strong>Total MI Area (in Acres):</strong> {{ getGrandTotalArea() | number:'1.2-2' }}
                        </div>
                        <div class="field md:col-3 col-12">
                            <strong>Total Farmer Share (₹):</strong> {{ getGrandTotalFarmerShare() | number:'1.2-2' }}
                        </div>
                        <div class="field md:col-3 col-12">
                            <strong>Total Center Share (₹):</strong> {{ getGrandTotalCenterShare() | number:'1.2-2' }}
                        </div>
                        <div class="field md:col-3 col-12">
                            <strong>Total State Share (₹):</strong> {{ getGrandTotalStateShare() | number:'1.2-2' }}
                        </div>
                        <div class="field md:col-3 col-12">
                            <strong>Total Top Up (₹):</strong> {{ getGrandTotalTopUp() | number:'1.2-2' }}
                        </div>
                        <div class="field md:col-3 col-12">
                            <strong>Overall Total Amount (₹):</strong> {{ getGrandTotalAmount() | number:'1.2-2' }}
                        </div>
                    </div> -->
                    
                    <div class="table-responsive">
                        <p-table [value]="groupedVendors" styleClass="p-datatable-gridlines sanction-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%">Sr. No.</th>
                                    <th style="width: 30%">Vendor Name</th>
                                    <th style="width: 10%">Beneficiary (No.)</th>
                                    <th style="width: 10%">Center Share Payment Amount</th>
                                    <th style="width: 10%">State Share Payment Amount</th>
                                    <th style="width: 10%">Top Up</th>
                                    <th style="width: 15%">Total Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                <tr>
                                    <td>{{ rowIndex + 1 }}</td>
                                    <td>{{ item?.vendorName }}</td>
                                    <td>{{ item?.beneficiaryCount }}</td>
                                    <td>{{ getVendorTotalCenterShare(item) | number:'1.2-2' }}</td>
                                    <td>{{ getVendorTotalStateShare(item) | number:'1.2-2' }}</td>
                                    <td>{{ getVendorTotalTopUp(item) | number:'1.2-2' }}</td>
                                    <td>{{ getVendorTotalAmount(item) | number:'1.2-2' }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td colspan="2" class="text-end fw-bold">Total</td>
                                    <td class="fw-bold">{{ getGrandTotalBeneficiaries() | number:'1.0-0' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalCenterShare() | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalStateShare() | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalTopUp() | number:'1.2-2' }}</td>
                                    <td class="fw-bold">{{ getGrandTotalAmount() | number:'1.2-2' }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <div class="header my-3 mx-5">
                        <div class="flex justify-content-start mx-0 my-3">
                            <p>It is certified that : -<br>
                                &nbsp;&nbsp;&nbsp; 1. The terms and conditions on the basis of which subsidy has proposed to be released have been fulfilled as per operational guidelines of PDMC scheme.<br>
                                &nbsp;&nbsp;&nbsp; 2. MI system installed is as per approved specification based on area specified by Farmers in their application and within approved cost/ estimate.<br>
                                &nbsp;&nbsp;&nbsp; 3. The benefit of scheme has extended to intended beneficiaries only one time and no payment were made earlier against these proposed application either to farmer or vendor.<br>
                                &nbsp;&nbsp;&nbsp; 4. The cases are submitted for first time for release of assistance.<br>
                                &nbsp;&nbsp;&nbsp; 5. The Farmer had deposited its 15% contribution as farmer share.<br>
                                &nbsp;&nbsp;&nbsp; 6. All required documents from both the vendors and beneficiary have been verified and uploaded on MI Portal.<br>
                            </p>
                        </div>
                    </div>
                </div>

                <!-- No data message -->
                <div class="alert alert-info mt-4" *ngIf="filteredVendors.length === 0">
                    <p> No vendor data available. </p>
                </div>
            </div>
        </div>

        <div class="certificate-container" *ngIf="miCertificateData && miSurveyData?.length > 0">
            <p-card styleClass="p-card-shadow">
                <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
                <div class="mt-2" id="printableArea">
                    <div class="print border bold" style="margin-top: 1px;">
                        <div class="flex align-items-center" style="display: flex; flex-direction: row; justify-content: center;">
                            <div style="flex: 0 0 auto;">
                                <img src="assets/activitiesImages/micada_new_logo.png" alt="MICADA Logo" width="100" height="70" class="mr-2 mt-1">
                            </div>
                            <div style="flex: 1 1 auto; text-align: center;">
                                <div class="mt-3 headings">
                                    <strong>{{'MICRO_IRR_COMP'| translate}}</strong><br>
                                    <strong>{{'HARYANA'| translate}}</strong><br>
                                    <strong>{{'FINANCIAL_YEAR_'| translate}}{{ selectedYear }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container mx-2 mt-3">
                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-between mx-5 my-3">
                                <p>Lot no. <b>{{ lotNo }}</b></p>
                                <p>Date the lot of print generated <b>{{ printGeneratedDate }}</b></p>
                            </div>
                        </div>

                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-center mx-5 my-3 certificate-header">
                                <!-- <p>Period date <b>{{ miCertificateData?.prevDate }}</b> to date <b>{{
                                            miCertificateData?.currentDate }}</b></p> -->
                                <p>ORDER</p>
                            </div>
                        </div>

                        <div class="header my-3 mx-5 text-justify">Sanction is hereby accorded for disbursement of
                            subsidy of Rs. <b>{{
                                getGrandTotalAmount() | number:'1.2-2' }}</b>
                            on a/c of installation of Micro Irrigation System <b>{{
                                miCertificateData?.Program_Name}}</b>
                            by the applicant farmer on farmer share basis to the registered vendors through E-Sparsh
                            portal as per GOI instructions from Centrally sponsored scheme code <b>{{
                                miCertificateData?.CenterSponsoredScheme }}</b>
                            and & State linked scheme code <b>{{ miCertificateData?.StateSponsoredScheme }}</b>.
                            <!-- total application <b>{{ miCertificateData?.totalChallanApp}}</b> Amount Rs. <b>{{
                                    miCertificateData?.totalChallanAmount }}</b>. -->
                        </div>
                        <div class="header my-3 mx-5 text-justify">
                            Administrator MICADA been the competent authority had sanctioned the expenditure as per
                            details under: -
                        </div>


                        <div class="table-responsive">
                            <p-table [value]="groupedVendors" styleClass="p-datatable-gridlines sanction-table">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 5%">Sn.</th>
                                        <th style="width: 25%">Name of Payee</th>
                                        <th style="width: 15%">Particular</th>
                                        <th style="width: 10%">Lot No.</th>
                                        <th style="width: 25%">E-office No. & Dated</th>
                                        <th style="width: 10%">Beneficiary (No.)</th>
                                        <th style="width: 10%">Total</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                    <tr>
                                        <td>{{ rowIndex + 1 }}</td>
                                        <td>{{ item?.vendorName }}</td>
                                        <td>Disbursement of Subsidy</td>
                                        <td>{{lotNo}}</td>
                                        <td>{{ item?.caoRemarks }}</td>
                                        <td>{{ item?.beneficiaryCount }}</td>
                                        <td>{{ getVendorTotalAmount(item) | number:'1.2-2' }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr>
                                        <td colspan="5" class="text-end fw-bold">Total</td>
                                        <td class="fw-bold">{{ getGrandTotalBeneficiaries() | number:'1.0-0' }}</td>
                                        <td class="fw-bold">{{ getGrandTotalAmount() | number:'1.2-2' }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>

                        <div class="header my-3 mx-5 text-justify">
                            The expenditure will be met out for the budget the head for F.Y. <b>{{
                                miCertificateData?.FinancialYear}}</b>.
                        </div>

                        <div class="header my-3 mx-5 text-justify">
                            <em>“Implementation of Pradhan Mantri Krishi Sinchayee Yojana- Per Drop More Crop”</em>
                            &nbsp; <b>{{ miCertificateData?.CasteDesc}}</b> &nbsp; Under Head <b>{{
                                miCertificateData?.PMKSYId}}</b>.
                        </div>

                        <!-- <div class="header my-3 mx-5">
                                <div class="flex justify-content-end mx-5 my-3">
                                    <div class="col-4 flex justify-content-end">
                                        <p>
                                            Engineer-in-Chief<br>
                                            Irrigation & W.R. Deptt.<br>
                                            Cum-Administrator, MICADA<br>
                                            Haryana (SNA-SPARSH)
                                        </p>
                                    </div>
                                </div>
                            </div> -->

                        <br><br><br>
                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-end mx-5 my-3">
                                <p>
                                    Engineer-in-Chief<br>
                                    Irrigation & W.R. Deptt.<br>
                                    Cum-Administrator, MICADA<br>
                                    Haryana (SNA-SPARSH)
                                </p>
                            </div>
                        </div>

                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-between mx-5 my-3">
                                <p>Endst. No./MICADA/<b>{{ miCertificateData?.eNo }}</b></p>
                                <p>Dated:- <b>{{ printGeneratedDate }}</b></p>
                                <!-- <p>Dated:- <b>{{ miCertificateData?.date }}</b></p> -->
                            </div>
                        </div>


                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-start mx-0 my-3">
                                <p>A copy is forwarded to the following for information and n/a please: -<br>
                                    &nbsp;&nbsp;&nbsp; 1. The Principal Accountant General (A&E), Haryana,
                                    Chandigarh.<br>
                                    &nbsp;&nbsp;&nbsp; 2. Treasury Officer, Cyber Treasury, Panchkula.<br>
                                    &nbsp;&nbsp;&nbsp; 3. Chief Accounts Officer, MICADA for making payment through
                                    E-Sparsh Portal. (Two copies)<br>
                                    &nbsp;&nbsp;&nbsp; 4. Xen (Drainage) H.Q. Panchkula of Irrigation & Water Resources
                                    Dept. (SNA- Sparsh) being DDO (PDMC- PMKSY).<br>
                                </p>
                            </div>
                        </div>

                        <br><br><br>
                        <div class="header my-3 mx-5">
                            <div class="flex justify-content-end mx-5 my-3">
                                <p> Director (MI)<br>
                                    For Administrator <br>
                                    MICADA, Panchkula
                                </p>
                            </div>
                        </div>

                        <!-- <div class="details mt-3">
                                <div class="flex justify-content-center bold mb-1">Certificate-1</div>
                                <div class="header my-3 mx-2 text-justify">The farmer share of <b>{{
                                        miCertificateData?.totalLotApp }}</b> no. of
                                    applications for amount Rs. <b>{{ miCertificateData?.totalLotAmount }}</b> has been
                                    received as per the portal report. This Lot is submitted for
                                    further processing as per the next process of verification and payment approval.
                                </div>
                                <div class="flex justify-content-end mx-5 mt-5 pt-5">
                                    Director /MI
                                </div>
                            </div> -->

                        <!-- <div class="details mt-3">
                                <div class="flex justify-content-center bold mb-1">Certificate-2</div>
                                <div class="header my-3 mx-2 text-justify">It is certified that the farmer share of each
                                    applications has been tallied with the bank account passbook and application wise
                                    amount has been credited
                                    in the Farmer share bank account of MICADA.
                                </div>
                                <div class="flex justify-content-end mx-5 mt-5 pt-5">
                                    CAO / Accounts Officer
                                </div>
                            </div> -->

                        <!-- <div class="details mt-3">
                                <div class="flex justify-content-center bold mb-1 pt-5">Certificate-3</div>
                                <div class="header my-3 mx-2 text-justify">The <b>{{ miCertificateData?.totalLotApp
                                        }}</b> no. of cases for Rs. <b>{{ miCertificateData?.prevDate }}</b> is
                                    submitted for approval and payment to <b>{{ miCertificateData?.NoOfVendors == null ?
                                        '___' : miCertificateData?.NoOfVendors }}</b> no. of vendors as per details of
                                    lot <b>{{ lotNo }}</b>
                                </div>
                                <div class="flex justify-content-end mx-5 mt-5">
                                    CAO
                                </div>
                            </div> -->
                    </div>
                </div>
                <!-- <div class="flex justify-content-around mt-5">
                        <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT'| translate}}"
                            (click)="onPrint('printableArea')"></button>
                    </div>  -->
            </p-card>
        </div>

        <div class="card">
            <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_FILTERED_FOR_MI_SUBSIDY_TO_VENDOR_LOT' | translate}}: {{
                    miSurveyData?.length }}</b>
            </h5>
            <!-- <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Farmer Amount: {{ totalSubToFarmer }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Vendor Amount: {{ totalSubToVendor }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Farmer Refund Amount: {{ totalFarmerRefund }}</p>
                    </div>
                </div> -->
            <div class="flex justify-content-end" *ngIf="miCertificateData && miSurveyData?.length > 0 && !isDuplicateFound">
                <!-- <button (click)="menu.toggle($event)" pButton pRipple p-button-info
                        label="Download Filtered Lot Data" icon="pi pi-upload"></button>
                        <p-menu #menu [popup]="true" [model]="appVerificationItems" styleClass="prime-slider-override"></p-menu> -->
                <p-splitButton [model]="appVerificationItems" icon="pi pi-download"
                    label="{{'EXPORT' | translate}}"></p-splitButton>
            </div>

            <!-- <div class="card">
                    <p-toolbar *ngIf="filteredData.length">
                        <ng-template pTemplate="left">

                        </ng-template>
                        <ng-template pTemplate="right">
                            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                class="mr-3">
                            </p-dropdown>
                            <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea
                                required rows="3" cols="20" class="mr-3"></textarea>
                            <button pButton pRipple label="Submit" (click)="handleClick()"
                                class="p-button-help"></button>
                        </ng-template>
                    </p-toolbar>
                </div> -->
        </div>

        <!-- </p-card> -->
    </div>
</p-dialog>